import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import mk from './locales/mk.json'
import en from './locales/en.json'
import sq from './locales/sq.json'
import tr from './locales/tr.json'

/** The four the platform speaks. English first, the default; the rest offered once from the browser. */
export const LANGUAGES = ['en', 'mk', 'sq', 'tr']

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      mk: { translation: mk },
      en: { translation: en },
      sq: { translation: sq },
      tr: { translation: tr },
    },
    fallbackLng: 'en',
    supportedLngs: LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      // Only what was chosen; the browser's language is a suggestion made once, not a setting.
      order: ['localStorage'],
      caches: ['localStorage'],
      // Its own key: the admin portal is a different app on a different hostname, and somebody
      // may well want it in English while the product they support is in Macedonian.
      lookupLocalStorage: 'doseg.admin.lang',
    },
  })

export default i18n
